import React, { Dispatch, SetStateAction, createContext, ReactNode, useState, useContext } from "react";


export type User = {
    name : string;
    codUser : string;
    permissions : string[];
    client : string;
    codClient: string;
    clientJiraCodMain: string | null;
    clientJiraCodSup: string | null;
}

export interface IUserContext {
    user : User,
    setUser : Dispatch<SetStateAction<User>>
}

const AuthContext = createContext<IUserContext>({} as IUserContext);

type UserProvideProps = {
    children: ReactNode
}

const AuthProvider : React.FC<UserProvideProps> = ({children}) => {

    const [user, setUser] = useState<User>({
        name : '',
        codUser : '',
        permissions : [],
        client : '',
        codClient: '',
        clientJiraCodMain: '',
        clientJiraCodSup: ''
    });

    return (
        <AuthContext.Provider value={{user, setUser}}>
            {children}
        </AuthContext.Provider>
    )

}

function useAuth(): IUserContext {
    const context = useContext(AuthContext);

    return context;
}

export {AuthProvider, useAuth};